import React from 'react';
import { comparisonRows } from '../data/comparison';
import { SectionHeading } from './SectionHeading';
const columns = [{
  key: 'hydrosprings' as const,
  label: 'Hydrosprings'
}, {
  key: 'salt' as const,
  label: 'Salt system'
}, {
  key: 'uvOzone' as const,
  label: 'UV / Ozone'
}, {
  key: 'ionizer' as const,
  label: 'Ionizer / Copper'
}];
export function ComparisonTable() {
  return <section className="border-t border-ink-950/8 bg-paper py-20 lg:py-28" data-id="element-17" data-mp="3ibpc0a9t9d3c">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-18" data-mp="3iae5i2ozdr8j">
        <SectionHeading eyebrow="Side by side" title="Hydrosprings compared to traditional systems." lede="Salt, UV, ozone, ionizers and copper all still manage chlorine. Hydrosprings removes the need for it." data-id="element-19" data-mp="3mcj2nben15zx" />

        <div className="mt-12 overflow-x-auto" data-id="element-20" data-mp="1wyw39k6mikm9">
          <table className="w-full min-w-[720px] border-collapse text-left" data-id="element-21" data-mp="1wy4bylk2791s">
            <caption className="sr-only" data-id="element-22" data-mp="21y8usi8fwfv6">
              Comparison of Hydrosprings against salt, UV, ozone, ionizer and
              copper pool systems
            </caption>
            <thead data-id="element-23" data-mp="29w3lr0givcw2">
              <tr data-id="element-24" data-mp="29wlrqoszl5h6">
                <th scope="col" className="w-[26%] pb-4 pr-6 text-xs uppercase tracking-[0.16em] text-ink-400" data-id="element-25" data-mp="29x55rufin9px">
                  &nbsp;
                </th>
                {columns.map(col => <th key={col.key} scope="col" className={`pb-4 pr-6 align-bottom font-display text-sm font-semibold ${col.key === 'hydrosprings' ? 'text-ink-950' : 'text-ink-600'}`} data-id="element-26" data-mp="2ivqk1ddyg2kw">
                    {col.key === 'hydrosprings' ? <span className="inline-flex items-center gap-2" data-id="element-27" data-mp="31nru7bw6jf9m">
                        <span className="h-1.5 w-1.5 rounded-full bg-aqua-500" data-id="element-28" data-mp="3glbsy12hge7c" />
                        {col.label}
                      </span> : col.label}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-29" data-mp="3noicit5dp0ha">
              {comparisonRows.map(row => <tr key={row.criterion} className="border-t border-ink-950/10" data-id="element-30" data-mp="3smtmr4zl5d01">
                  <th scope="row" className="py-5 pr-6 align-top text-sm font-medium text-ink-950" data-id="element-31" data-mp="3skqqi37uanmv">
                    {row.criterion}
                  </th>
                  {columns.map(col => <td key={col.key} className={`py-5 pr-6 align-top text-sm ${col.key === 'hydrosprings' ? 'bg-aqua-50/70 font-medium text-ink-950' : 'text-ink-600'}`} data-id="element-32" data-mp="a6zj0t49l19i">
                      {row[col.key]}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}